import { useMemo } from 'react';
import * as _ from 'lodash';
import { useApi } from './api';

export const useTeamNews = (abbrv, postAmount) => {
  const [data, loading, error] = useApi(
    `team/news?id=${abbrv}&limit=${postAmount}`
  );

  const articles = useMemo(
    () => _.uniqBy(data, 'articleUrl'),
    [data, loading, error]
  );

  return [articles, loading, error];
};
